// https://codepen.io/jordanhope/pen/EyGkRv

import React from 'react';

class LikeDislike extends React.Component {
    constructor() {
      super();
      this.state = {
        liked: false
      };
      this.handleClick = this.handleClick.bind(this);
    } 
    
    handleClick() {
      this.setState({
        liked: !this.state.liked
      });
    }
    
    render() {
      const text = this.state.liked ? 'liked' : 'haven\'t liked';
      const label = this.state.liked ? 'Unlike' : 'Like'
      return (
        <div className="customContainer">
          <button className="btn btn-info" onClick={this.handleClick} style={{marginTop: 30, color: "white"}}>
            {label}</button>
          <p style={{color: "SteelBlue"}}>
            You {text} this. Click to toggle.
          </p>
        </div>
      );
    }
  }
  
//   ReactDOM.render(
//     <LikeButton />,
//     document.getElementById('example')
//   )

export default LikeDislike;